// ** I18n Imports
import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { updateDocumentLang } from "@/Core/utils";
import { getCurrentCountryCode } from "@/utils/countryConfigUtils";

/**
 * 从 country-config.js 获取当前域名对应的语言配置
 */
const getCountryLang = (): string => {
  const countryCode = getCurrentCountryCode();
  
  if (typeof window !== "undefined" && (window as any).__COUNTRY_CONFIG__) {
    const config = (window as any).__COUNTRY_CONFIG__;
    
    if (countryCode && config.countries[countryCode]) {
      return config.countries[countryCode].lang;
    }
  }
  
  // 默认回退到英语
  return "en_US";
};

/**
 * 从 country-config.js 获取所有支持的语言列表
 */
const getSupportedLanguages = (): string[] => {
  if (typeof window !== "undefined" && (window as any).__COUNTRY_CONFIG__) {
    const config = (window as any).__COUNTRY_CONFIG__;
    const languages = new Set<string>();
    
    // 收集所有国家配置中的语言
    Object.values(config.countries).forEach((country: any) => {
      if (country.lang) {
        languages.add(country.lang);
      }
    });
    
    return Array.from(languages);
  }
  
  // 默认支持的语言
  return ["en_US", "fr_FR"];
};

const currentLang = getCountryLang();
const supportedLngs = getSupportedLanguages();

i18n
  // load translation using http
  .use(Backend)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    lng: currentLang, // 使用配置文件中的语言，不再自动检测
    fallbackLng: "en_US",
    debug: false,
    supportedLngs: supportedLngs,
    backend: {
      /* translation file path */
      loadPath: `${
        window.location.origin
      }/locales/{{lng}}.json?version=${new Date().getTime()}`,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  });

// 添加语言变更监听器，自动更新 HTML lang 属性
i18n.on("languageChanged", (lng) => {
  updateDocumentLang(lng);
});

// 初始化时设置 HTML lang 属性
updateDocumentLang(currentLang);

export default i18n;
